import { useMutation } from '@tanstack/react-query'
import { api } from '@api'

interface AnalyzeParams {
  conversationId: string
}

interface AnalyzeResponse {
  sentiment: string | null
  topics: string[]
  dynamics: string
  keyPoints: string[]
}

const analyzeConversation = async (params: AnalyzeParams): Promise<AnalyzeResponse> => {
  const { data } = await api.post<AnalyzeResponse>('/ft_conversation-ai/analyze', params)
  return data
}

export const useFtConversationAiAnalyze = () => {
  return useMutation<AnalyzeResponse, Error, AnalyzeParams>({
    mutationFn: analyzeConversation,
  })
}
